define(function (require, exports) {
    'use strict';
    
    // @ngInject
    exports.message = function () {
      return {
        restrict: 'E',
        scope: {
          message: '@',
          type: '@'
        },
        template: `
              <div ng-class="{'error': type === 'ERROR' || type === 'INLINE-ERROR'}" class="message">
                <span ng-class="{'message-type-error-icon': type === 'ERROR', 'message-type-inline-error-icon': type === 'INLINE-ERROR', 'message-type-warning-icon': type === 'WARNING', 'message-type-info-icon': type === 'INFO'}"></span>
                <p ng-class="{'message-type-error': type === 'ERROR', 'message-type-inline-error': type === 'INLINE-ERROR', 'message-type-warning': type === 'WARNING', 'message-type-info': type === 'INFO'}">{{message}}</p>
              </div>
              `
      }
    }
  });


// WEBPACK FOOTER //
// ./scripts/directives/message.js